import React, {useEffect, useState} from 'react';
import {useNavigate, useSearchParams} from "react-router-dom";
import "../../style/login/_login.scss";
import Layout from "../layout/Layout";
import {useLoading} from "../components/loading/LoadingProvider";
import {post} from "../utils/FetchUtil";
import {getUrlParamErrorCode} from "../utils/UrlsUtil";
import {isNotEmpty, nullToBlank} from "../utils/CommonUtil";
import {getErrorMessage} from "../const/ErrorMessageConst";
import {useAuth} from "../components/auth/AuthProvider.tsx";


interface LoginFormData {
    order_number: string;
    email: string;
    error_list?: [];
}

interface LoginProps {}

const LoginPage: React.FC<LoginProps> = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [validated, setValidated] = useState(false);
    const [errorList, setErrorList] = useState([]);
    const [loginFormData, setLoginFormData] = useState<LoginFormData>({order_number: '', email: ''});
    const { showLoading, hideLoading, isLoading } = useLoading();
    const { logout } = useAuth();
    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = event.target;
        setLoginFormData({ ...loginFormData, [name]: value });
    };
    const onClickSendMail = async () => {
        setErrorList([]);
        setValidated(true);
        const form = document.getElementById("loginForm");
        // @ts-ignore
        if (!form.checkValidity()) {
            return;
        }
        setValidated(false);
        showLoading();
        post<LoginInfoDto>({
            action: "/api/login/send_code",
            data: {order_number: loginFormData.order_number, email: loginFormData.email}
        })
            .then(() => {
                navigate("/login/code");
            })
            .catch((reason) => {
                // @ts-ignore
                setErrorList([reason.message]);
            })
            .finally(() => {
                hideLoading();
            });
    }
    useEffect(() => {
        const initErrorCode = getUrlParamErrorCode(searchParams);
        if(isNotEmpty(initErrorCode)){
            // @ts-ignore
            setErrorList([getErrorMessage(initErrorCode)]);
        }
        logout();
    }, [searchParams]);
    return (
        <Layout page_meta = {{title: 'ログイン｜ギフトアレンジ'}}
                error_list={errorList}
                show_footer={true}
        >
            <section className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <p className="login-title">
                            「オンラインギフトのギーバ」<br/>
                            楽天市場店データ入力サイト
                        </p>
                    </div>
                </div>
                <div className="row">
                    <div className="col"></div>
                    <div className="col-12 col-md-auto">
                        <div className="login-box">
                            このサイトは、「<strong>オンラインギフトのギーバ</strong>」<strong>の楽天市場店</strong>で、<br className="pc"/>
                            ギフトを注文いただいた方専用のデータ入力を行うサイトです。<br/>
                            <br/>
                            のし・包装やオンデマンドカードなどの包装資材に<strong>印刷するデータ入力</strong>や、<br className="pc"/>
                            無料の<strong>オンラインメッセージのデータ入力</strong>を御承りしております。<br/>
                        </div>
                        <div className="login-box input">
                            <p className="mb-4">
                                ※楽天市場でご注文時の情報を入力してください。<br/>
                                ※弊社からのメールが受信できるよう、ドメイン（ecmall@geeva.co.jp）の受信設定をお願いいたします。
                            </p>
                            <form id="loginForm" className={validated ? "form-group row was-validated" : "form-group w-100"}>
                                <div className="row">
                                    <label htmlFor="order_number" className="col-12 col-md-3 col-form-label my-text-bold">楽天注文番号</label>
                                    <div className="col-12 col-md-9">
                                        <input type="text" id="order_number" className="form-control" name="order_number" required value={nullToBlank(loginFormData.order_number)} placeholder="000000-00000000-0000000000"
                                               onChange={handleInputChange}/>
                                        <div className="invalid-feedback">楽天注文番号をご入力ください</div>
                                    </div>
                                </div>
                                <div className="row mt-3">
                                    <label htmlFor="email" className="col-12 col-md-3 col-form-label my-text-bold">メールアドレス</label>
                                    <div className="col-12 col-md-9">
                                        <input type="email" id="email" className="form-control" name="email" required value={nullToBlank(loginFormData.email)} placeholder="mail@example.jp"
                                               onChange={handleInputChange}/>
                                        <div className="invalid-feedback">メールアドレスをご入力ください</div>
                                    </div>
                                </div>
                            </form>
                            <div className="mt-4">
                                <button className="btn btn-danger" onClick={onClickSendMail} disabled={isLoading}>メールを送信</button>
                            </div>
                        </div>
                    </div>
                    <div className="col"></div>
                </div>
            </section>
        </Layout>
    );
};
export default LoginPage;